<template>
    <kiosk-org-unit-details :teamId="props.teamId" :orgUnitId="props.orgUnitId">
        <div class="flex flex-col w-full justify-center">
            <div class="max-w-(--breakpoint-sm) flex flex-col">
                <page-callout section="kiosk-org-unit-historical-invoices" class="mb-4" />

                <page-loading v-if="loading"></page-loading>
                <template v-else>
                    <org-unit-historical-invoices :teamId="props.teamId" :orgUnitId="orgUnit.id" />
                </template>
            </div>
        </div>
    </kiosk-org-unit-details>
</template>

<script setup>
import OrgUnitHistoricalInvoices from '~/components/settings/billing/OrgUnitHistoricalInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import KioskOrgUnitDetails from '~/components/kiosk/kiosk-org-units/details/KioskOrgUnitDetails.vue';
import { useOrgUnitDetails } from '~/components/kiosk/kiosk-org-units/composables/useOrgUnitDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const { orgUnit, loading } = useOrgUnitDetails();
</script>
